(function () {
    angular.module('tradersyard').directive('inviteForm', InviteFormDirectiveFactory);

    InviteFormDirectiveFactory.$inject = [
        '$rootScope',
        '$parse',
        'graph-search-factory',
        'graph-friend-factory',
        'graph-participant-factory',
        'graph-invite-factory',
        '$flex',
        '$socket',
        '$flex.scroll',
    ];

    function InviteFormDirectiveFactory(
        $rootScope,
        $parse,
        $search,
        $friend,
        $participant,
        $invite,
        $flex,
        $socket,
        $scroll
    ) {
        return {
            scope: true,
            link: link,
            controller: ['$scope', controller],
            /**
             * @typedef {controller} inviteFormCtrl
             */
            controllerAs: 'inviteFormCtrl',
        };

        function link($scope, $element, $attr) {
            var knowing = ['friend', 'entry', 'all-participant', 'viaEmail'],
                tab,
                initialized = [],
                scrollGroup;

            $scope.expanded = false;
            $scope.entry = $parse($attr.entry)($scope);
            $scope.privacy = $parse($attr.privacy)($scope);

            $rootScope.$on('invite:custom', function (e, data) {
                $scope.entry = $attr.entry = data.entry;
                $scope.entry = $attr.entryId = data.entryId;
                $scope.clientReInit(data.entry, data.entryId);

                if (data.groups.length) {
                    $scope.selectedGroups = data.groups.map(function (group) {
                        return group.id;
                    });
                }
            });

            $scope.tab = {
                init: function () {
                    scrollGroup = $scroll.group.current;
                    $scroll.switch('roles');
                    $scope.tab.set($scope.entry ? knowing[0] : 'viaEmail');
                },
                is: function (name) {
                    return tab === name;
                },
                set: function (name) {
                    tab = name;

                    var init = initialized.indexOf(name) === -1;

                    if (init) initialized.push(name);

                    if ($scope.tab.on.change) $scope.tab.on.change(name, init);
                },
                on: {
                    change: undefined,
                },
            };

            var openBtn = angular.element($element[0].querySelector('[invite-open]')),
                closeBtn = angular.element($element[0].querySelector('[invite-close]')),
                body = angular.element(document.querySelector('body'));

            $scope.mode = $parse($attr.mode)($scope);

            $scope.params = {
                friend: {
                    page: 0,
                    let: 0,
                    limit: 25,
                },
                allParticipant: {
                    page: 0,
                    limit: 25,
                },
                ownership: {
                    page: 0,
                },
            };

            $scope.emails = [''];

            var collection = {
                ownership: {
                    place: '',
                },
            };

            $scope.showModal = false;

            $scope.nodes = {
                friend: [],
                ownership: [],
                allParticipant: [],
                currentSelectedParticipant: [],
            };

            $scope.extended = $parse($attr.extended)($scope);

            $scope.client = {
                friend: $friend.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                search: $search.place($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                participant: $participant.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
                invite: $invite.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope)),
            };

            $scope.clientReInit = function (entry, id) {
                $scope.client.participant = $participant.entry(entry, id);
                $scope.client.friend = $friend.entry(entry, id);
                $scope.client.search = $search.place(entry, id);
                $scope.client.invite = $invite.entry(entry, id);
            };

            $scope.expandAdditionalInfo = function (node) {
                var query = 'group' + '.' + node.id;
                // $scope.expanded = true;
                $scope.getParticipantByGroup(query, node);
            };

            $scope.hideDetails = function () {
                $scope.expanded = false;
            };

            $scope.participantPage = 1;

            $scope.getParticipantByGroup = function (q, node) {
                $scope.nodes.currentSelectedParticipant = [];
                node.loader = true;

                var params = {
                    page: $scope.participantPage,
                    place: q,
                    limit: 25,
                };

                $scope.client.search.search('participant', { params: params }).then(function (response) {
                    if (response.data.state === 0) {
                        $scope.nodes.currentSelectedParticipant = $scope.nodes.currentSelectedParticipant.concat(
                            response.data.data
                        );

                        $scope.participantPage++;
                        if (response.data.data.length === params.limit) {
                            $scope.getParticipantByGroup(q, node);
                        } else {
                            node.loader = false;
                            $scope.expanded = true;
                            $scope.participantPage = 1;
                        }
                        // if (next) next();
                    } else {
                        node.loader = false;
                        node.error = true;
                        $scope.participantPage = 1;
                    }
                });
            };

            $scope.massInvite = function (node) {
                $scope.client.invite.massInvite(node.place.name, node.place.id).then(function (response) {
                    if (response.data.state === 0) {
                        for (var i = 0; i < $scope.nodes.ownership.length; ++i) {
                            node.invite.allow = false;
                            node.invite.pending += node.invite.available;
                            node.invite.available = 0;
                        }

                        digest();
                    }
                });
            };

            $scope.addEmailInput = function () {
                $scope.emails.push('');
            };

            $scope.inviteViaEmail = function () {
                if ($scope.entry) {
                    $scope.client.invite
                        .viaEmail({
                            emails: $scope.emails,
                        })
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.emails = [''];
                                hide();
                                digest();
                            }
                        });
                } else {
                    $scope.client.invite
                        .inviteToRegister({
                            emails: $scope.emails,
                        })
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.emails = [''];
                                hide();
                                digest();
                            }
                        });
                }
            };

            $scope.removeEmailInput = function (index) {
                if ($scope.emails.length > 1) {
                    $scope.emails.splice(index, 1);
                }
            };

            $scope.invite = function (node) {
                var data = $attr.inviteRole ? { promote: $parse($attr.inviteRole)($scope) } : {};

                $scope.client.invite.create(node.id, data).then(function (response) {
                    if (response.data.state === 0) {
                        node.is_invited = true;
                    }
                });
            };

            var ownership = function (end) {
                ++$scope.params.ownership.page;
                $scope.client.participant.ownership({ params: $scope.params.ownership }).then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.nodes.ownership = $scope.nodes.ownership.concat(response.data.data);

                        if ($scope.selectedGroups) {
                            angular.forEach(response.data.data, function (item) {
                                if ($scope.selectedGroups.includes(item.id)) {
                                    var value =
                                        collection.ownership.place === ''
                                            ? item.place.name + '.' + item.place.id
                                            : ',' + item.place.name + '.' + item.place.id;

                                    collection.ownership.place = collection.ownership.place.concat(value);
                                }
                            });
                        } else {
                            angular.forEach(response.data.data, function (item) {
                                var value =
                                    collection.ownership.place === ''
                                        ? item.place.name + '.' + item.place.id
                                        : ',' + item.place.name + '.' + item.place.id;

                                collection.ownership.place = collection.ownership.place.concat(value);
                            });
                        }
                        ownership(end);
                    } else if (response.data.state === 0) {
                        if ($scope.selectedGroups) {
                            $scope.nodes.ownership = $scope.groupFilter();
                        }
                        if (end) end();
                    }
                });
            };

            $scope.groupFilter = function () {
                return $scope.nodes.ownership.filter(function (group) {
                    return $scope.selectedGroups.includes(group.id);
                });
            };

            $scope.tab.on.change = function (name, init) {
                if (init === true) {
                    if (name === 'allParticipant' && initialized.indexOf('entry') === -1) {
                        ownership(function () {
                            $scope.params.allParticipant = angular.extend(
                                $scope.params.allParticipant,
                                collection.ownership
                            );
                            $scope.load[name]();
                        });
                    } else if (name === 'entry' && initialized.indexOf('allParticipant') === -1) {
                        ownership(function () {
                            $scope.params.allParticipant = angular.extend(
                                $scope.params.allParticipant,
                                collection.ownership
                            );
                        });
                    } else if (name !== 'viaEmail') {
                        $scope.load[name]();
                    }
                }

                $flex.$scroll.renew('participant');
            };

            angular.element(document.querySelector('body')).bind('keydown keypress', function (e) {
                if (e.which === 27) {
                    if ($scope.showModal === true) {
                        closeBtn.triggerHandler('click');

                        e.preventDefault();
                    }
                }
            });

            var digest = function () {
                if (!$scope.$$phase) {
                    $scope.$digest();
                }
            };

            var expand = function () {
                if ($scope.showModal === true) return;

                $scope.tab.init();

                body.addClass('no-scroll');
                $scope.showModal = true;
                digest();
            };

            var hide = function () {
                body.removeClass('no-scroll');
                $scope.showModal = false;
                $rootScope.$broadcast('invite-form-close');
                $flex.$scroll.renew('roles');
                $scroll.switch(scrollGroup);
                scrollGroup = undefined;
                digest();
            };

            $scope.hide = hide;

            $socket.on('friend:friend', function (data) {
                $scope.client.friend.read(data.user.id).then(function (response) {
                    if (response.data.state === 0) {
                        ++$scope.params.friend.let;
                        $scope.nodes.friend.unshift(response.data.data);
                        if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                            $rootScope.$apply();
                        }
                    }
                });
            });

            $socket.on('friend:unfriend', function (data) {
                --$scope.params.friend.let;

                $scope.nodes.friend.forEach(function (friend, i) {
                    if (friend.id === data.user.id) {
                        $scope.nodes.friend.splice(i, 1);
                    }
                });

                if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                    $rootScope.$apply();
                }
            });

            $scope.$on('invite-form-open', expand);

            openBtn.bind('click', expand);

            closeBtn.bind('click', hide);
        }

        function controller($scope) {
            $scope.paging = {
                friend: function (next) {
                    ++$scope.params.friend.page;
                    $scope.client.friend.query({ params: $scope.params.friend }).then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            $scope.nodes.friend = $scope.nodes.friend.concat(response.data.data);

                            if (next) next();
                        }
                    });
                },
                allParticipant: function (next) {
                    ++$scope.params.allParticipant.page;
                    $scope.client.search
                        .search('participant', { params: $scope.params.allParticipant })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.nodes.allParticipant = $scope.nodes.allParticipant.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };

            $scope.load = {
                friend: function (next, q) {
                    if (q !== undefined && q !== '') {
                        $scope.params.friend.page = 0;
                        $scope.nodes.friend = [];
                        $scope.params.friend = angular.extend($scope.params.friend, { q: q });
                        ++$scope.params.friend.page;
                        $scope.client.search
                            .search('friend', { params: $scope.params.friend })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.nodes.friend = $scope.nodes.friend.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    } else {
                        $scope.params.friend.page = 0;
                        $scope.nodes.friend = [];

                        ++$scope.params.friend.page;
                        $scope.client.friend.query({ params: $scope.params.friend }).then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.nodes.friend = $scope.nodes.friend.concat(response.data.data);

                                if (next) next();
                            }
                        });
                    }
                },
                allParticipant: function (next, q) {
                    if (q !== undefined) {
                        $scope.params.allParticipant.page = 0;
                        $scope.nodes.allParticipant = [];
                        $scope.params.allParticipant = angular.extend($scope.params.allParticipant, { q: q });
                    }
                    ++$scope.params.allParticipant.page;
                    $scope.client.search
                        .search('participant', { params: $scope.params.allParticipant })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.nodes.allParticipant = $scope.nodes.allParticipant.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };
        }
    }
})();
